const guideStyles = {
  page: {
    minHeight: "100%",
    bgcolor: "#f4f7fb",
    color: "#14213a",
    px: { xs: 1.5, sm: 2.5, lg: 3 },
    py: { xs: 2, sm: 3 },
  },
  hero: {
    position: "relative",
    overflow: "hidden",
    mb: 2.5,
    p: { xs: 2.5, sm: 4 },
    border: "1px solid #203b61",
    borderRadius: 3,
    bgcolor: "#132946",
    color: "#fff",
    boxShadow: "0 18px 45px rgba(15, 35, 62, 0.16)",
    "&::after": {
      content: '""',
      position: "absolute",
      width: 280,
      height: 280,
      right: -100,
      top: -150,
      borderRadius: "50%",
      background: "rgba(29, 196, 211, 0.13)",
    },
  },
  heroIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 48,
    height: 48,
    mb: 2,
    borderRadius: 2,
    bgcolor: "rgba(255,255,255,0.1)",
    color: "#6de3ec",
  },
  heroEyebrow: {
    color: "#77e1e9",
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 1.3,
    textTransform: "uppercase",
  },
  heroTitle: {
    mt: 0.5,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: { xs: "1.8rem", sm: "2.5rem" },
    fontWeight: 700,
    lineHeight: 1.15,
  },
  heroDescription: {
    maxWidth: 760,
    mt: 1.5,
    color: "#d7e3f2",
    fontSize: { xs: 14, sm: 16 },
    lineHeight: 1.7,
  },
  standardChip: {
    mt: 2,
    maxWidth: "100%",
    height: "auto",
    borderColor: "rgba(255,255,255,0.28)",
    color: "#fff",
    "& .MuiChip-label": {
      display: "block",
      whiteSpace: "normal",
      py: 0.75,
    },
  },
  mobileToc: {
    display: { xs: "block", lg: "none" },
    mb: 2,
    border: "1px solid #d7e1ef",
    borderRadius: 2,
    boxShadow: "none",
    "&::before": { display: "none" },
  },
  layout: {
    display: "grid",
    gridTemplateColumns: { xs: "minmax(0, 1fr)", lg: "250px minmax(0, 1fr)" },
    gap: 2.5,
    alignItems: "start",
  },
  desktopToc: {
    display: { xs: "none", lg: "block" },
    position: "sticky",
    top: 86,
    maxHeight: "calc(100vh - 110px)",
    overflowY: "auto",
    border: "1px solid #d7e1ef",
    borderRadius: 2.5,
    bgcolor: "#fff",
    boxShadow: "0 8px 24px rgba(22, 43, 72, 0.07)",
  },
  tocTitle: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 2,
    py: 1.6,
    borderBottom: "1px solid #e3eaf3",
    color: "#183b62",
    fontSize: 13,
    fontWeight: 800,
  },
  tocList: {
    m: 0,
    p: 1,
    listStyle: "none",
  },
  tocLink: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    minHeight: 40,
    gap: 1,
    px: 1.25,
    py: 0.75,
    border: 0,
    borderRadius: 1.5,
    bgcolor: "transparent",
    color: "#5d6f88",
    cursor: "pointer",
    font: "inherit",
    fontSize: 12.5,
    lineHeight: 1.35,
    textAlign: "left",
    transition: "background-color 150ms ease, color 150ms ease",
    "&:hover": { bgcolor: "#edf7f8", color: "#087b87" },
    "&:focus-visible": { outline: "2px solid #00a3b4", outlineOffset: 1 },
  },
  tocLinkActive: {
    bgcolor: "#e7f7f9",
    color: "#007b88",
    fontWeight: 800,
  },
  tocNumber: {
    minWidth: 25,
    color: "inherit",
    fontFamily: "monospace",
    fontSize: 11,
    fontWeight: 800,
  },
  content: {
    display: "flex",
    minWidth: 0,
    flexDirection: "column",
    gap: 2.25,
  },
  section: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "auto",
    minHeight: 0,
    overflow: "visible",
    justifyContent: "initial",
    top: "auto",
    zIndex: "auto",
    p: 0,
    scrollMarginTop: 88,
    border: "1px solid #d7e1ef",
    borderRadius: 2.5,
    bgcolor: "#fff",
    boxShadow: "0 8px 25px rgba(21, 43, 73, 0.055)",
    outline: "none",
    "&::before": {
      content: "none",
      display: "none",
    },
  },
  sectionHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.5,
    p: { xs: 2, sm: 2.5 },
    borderBottom: "1px solid #e1e9f3",
    bgcolor: "#edf2f8",
  },
  sectionNumber: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 38,
    height: 38,
    flexShrink: 0,
    borderRadius: 1.5,
    bgcolor: "#183b62",
    color: "#fff",
    fontFamily: "monospace",
    fontSize: 12,
    fontWeight: 800,
  },
  sectionTitle: {
    color: "#17395e",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: { xs: "1.15rem", sm: "1.35rem" },
    fontWeight: 700,
    lineHeight: 1.25,
  },
  sectionIcon: {
    color: "#008f9d",
    fontSize: 20,
    verticalAlign: "middle",
    mr: 0.75,
  },
  sectionBody: {
    p: { xs: 2, sm: 2.5 },
  },
  introduction: {
    m: 0,
    color: "#4d5f78",
    fontSize: 14,
    lineHeight: 1.75,
  },
  cardsGrid: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))", xl: "repeat(3, minmax(0, 1fr))" },
    gap: 1.5,
    mt: 2,
  },
  infoCard: {
    p: 1.75,
    border: "1px solid #dce5f0",
    borderRadius: 2,
    bgcolor: "#fbfcfe",
  },
  infoCardTitle: {
    mb: 0.7,
    color: "#183b62",
    fontSize: 13.5,
    fontWeight: 800,
  },
  bodyText: {
    m: 0,
    color: "#53647b",
    fontSize: 13.5,
    lineHeight: 1.65,
  },
  subTitle: {
    mt: 2.25,
    mb: 1,
    color: "#24486f",
    fontSize: 13,
    fontWeight: 800,
    letterSpacing: 0.25,
  },
  steps: {
    display: "grid",
    gap: 1.15,
    mt: 2,
  },
  step: {
    display: "grid",
    gridTemplateColumns: "34px minmax(0, 1fr)",
    gap: 1.25,
    alignItems: "start",
  },
  stepNumber: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: "50%",
    bgcolor: "#e7f7f9",
    color: "#007f8c",
    fontSize: 12,
    fontWeight: 900,
  },
  stepContent: {
    pb: 1.2,
    borderBottom: "1px dashed #d8e2ed",
  },
  tableWrap: {
    mt: 1,
    border: "1px solid #d5dfec",
    borderRadius: 2,
    boxShadow: "none",
  },
  table: {
    minWidth: 620,
    "& th": {
      bgcolor: "#193d63",
      color: "#fff",
      fontSize: 12,
      fontWeight: 800,
      lineHeight: 1.35,
    },
    "& td": {
      color: "#455970",
      fontSize: 12.5,
      lineHeight: 1.55,
      verticalAlign: "top",
    },
    "& tbody tr:nth-of-type(even)": { bgcolor: "#f8fafc" },
  },
  callout: {
    display: "grid",
    gridTemplateColumns: "30px minmax(0, 1fr)",
    gap: 1.25,
    mt: 2,
    p: 1.6,
    border: "1px solid",
    borderRadius: 2,
  },
  calloutInfo: { borderColor: "#b9dce8", bgcolor: "#f0f9fc", color: "#17637a" },
  calloutTip: { borderColor: "#bde4ce", bgcolor: "#f0faf4", color: "#17683d" },
  calloutWarning: { borderColor: "#ecd8a2", bgcolor: "#fff9e9", color: "#765817" },
  calloutTitle: { mb: 0.35, fontSize: 13, fontWeight: 900 },
  bulletList: {
    m: 0,
    pl: 2.5,
    color: "#52647b",
    fontSize: 13.5,
    lineHeight: 1.8,
    "& li::marker": { color: "#00a3b4" },
  },
  faqList: {
    display: "grid",
    gap: 1,
    mt: 2,
  },
  faqItem: {
    border: "1px solid #dce5ef",
    borderRadius: 2,
    boxShadow: "none",
    "&::before": { display: "none" },
  },
  faqQuestion: { color: "#183b62", fontSize: 13.5, fontWeight: 800 },
  footer: {
    py: 2,
    color: "#718096",
    fontSize: 12,
    textAlign: "center",
  },
};

export default guideStyles;
